import { StyleSheet, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { AccountMenuProps } from './AccountMenu.types';
import { ACCOUNT_TAB } from './AccountMenu.constants';
import { STYLE_VARS } from '../../constants/style-vars';
import { Promotions } from '../../screens/Home/components/Promotions';
import UserWebInfo from '../UserWebInfo';
import Sidebar from '../Sidebar';

const AccountMenu: FC<AccountMenuProps> = ({ current = 0 }) => {
  return (
    <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
      <UserWebInfo />
      <View style={{ marginTop: 30, backgroundColor: STYLE_VARS.fccLightGrey }}>
        <Sidebar data={ACCOUNT_TAB} current={current} />
      </View>
      <Promotions />
    </View>
  );
};

export default AccountMenu;

const styles = StyleSheet.create({});
